import React from 'react';
import { IconProps } from './model/IconInterface';

const MapPinIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M12 22s8-7 8-13a8 8 0 0 0-16 0c0 6 8 13 8 13z' />
        <circle cx='12' cy='9' r='3' />
    </svg>
);

export default MapPinIcon;
